import { Switch } from "@headlessui/react";

interface SwitchProps {
  label: string;
  error?: string;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
}

const CustomSwitch = ({
  label,
  error,
  checked = false,
  onChange,
}: SwitchProps) => {
  return (
    <div>
      <Switch.Group>
        <div className="flex items-center gap-3">
          <Switch
            checked={checked}
            onChange={onChange}
            className={`${
              checked ? "bg-primary" : "bg-neutral-200"
            } relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2`}
          >
            <span
              className={`${
                checked ? "translate-x-6" : "translate-x-1"
              } inline-block h-4 w-4 transform rounded-full bg-white transition-transform`}
            />
          </Switch>
          <Switch.Label className="cursor-pointer text-sm font-medium text-neutral-700">
            {label}
          </Switch.Label>
        </div>
      </Switch.Group>
      {error && <p className="mt-1 text-sm text-error">{error}</p>}
    </div>
  );
};

export default CustomSwitch;
